import { BRAND } from "@/lib/brand";

// Renders the official circular "The Way Forward . Solutions" logo on a
// clean white disc so it remains legible against any background.
// `framed` adds a soft gold ring; default true.
export default function LogoMark({ size = 44, className = "", framed = true }) {
  const s = size;
  return (
    <div
      className={`inline-flex items-center justify-center ${className}`}
      style={{
        width: s,
        height: s,
        borderRadius: "9999px",
        background: "#FFFFFF",
        border: framed ? "1px solid var(--gold-500)" : "none",
        boxShadow: framed ? "0 0 0 2px rgba(212,175,55,0.12)" : "none",
        overflow: "hidden",
        flexShrink: 0,
      }}
      aria-label="The Way Forward.solutions logo"
    >
      <img
        src={BRAND.assets.logo}
        alt="The Way Forward.solutions logo"
        crossOrigin="anonymous"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  );
}
